import { render, staticRenderFns } from "./FilterDiscipline.vue?vue&type=template&id=59dc8834&"
import script from "./FilterDiscipline.controller.js?vue&type=script&lang=js&"
export * from "./FilterDiscipline.controller.js?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./FilterDiscipline.styles.scss?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "15a8c974"
  
)

export default component.exports